import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from "./router";
import store from "./store/index";
import BaiduMap from 'vue-baidu-map'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import captcha from 'vue-social-captcha'
import SlideVerify from 'vue-monoplasty-slide-verify';
// import wxCode  from './components/wxcode/wxcode.vue';
import Vant from 'vant';
import 'vant/lib/index.css';


Vue.use(SlideVerify);
Vue.use(captcha)

// Vue.use(wxCode)
Vue.use(ElementUI);
Vue.use(Vant);
Vue.use(router)
Vue.use(VueAwesomeSwiper)
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak:'LfTC52Z7B6atykSVKjcZ6lq4oK3Bmp8H'
})

Vue.config.productionTip = false

// new Vue({
//   el: "#app",
//   router,
//   components: { App },
//   template: "<App/>"
// });
new Vue({
  render: h => h(App),
    // 注册路由
    router,
	store
}).$mount('#app')
